import { useApp } from '../context.js';

export default function TrashList() {
    const { deletedRestaurants, permanentlyDeleteRestaurant, restoreRestaurant, setShowTrash } = useApp();
    return (
        <div className="space-y-3">
            <div className="bg-red-50 rounded-2xl p-4 mb-4">
                <h3 className="text-lg font-bold text-red-700 mb-1">🗑️ Trash</h3>
                <p className="text-sm text-red-600">
                    {deletedRestaurants.length === 0
                        ? 'No deleted restaurants'
                        : `${deletedRestaurants.length} deleted restaurant${deletedRestaurants.length === 1 ? '' : 's'}`}
                </p>
            </div>
            {deletedRestaurants.map((restaurant) => (
                <div key={restaurant.id} className="bg-white/90 apple-card rounded-2xl shadow-md overflow-hidden opacity-75">
                    <div className="p-4">
                        <div className="flex items-center justify-between">
                            <div>
                                <h3 className="text-lg font-bold text-gray-600 line-through">{restaurant.name}</h3>
                                <p className="text-xs text-gray-400">
                                    Deleted {new Date(restaurant.deletedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                </p>
                            </div>
                            <div className="flex gap-2">
                                <button
                                    onClick={() => restoreRestaurant(restaurant.id)}
                                    className="bg-green-500 text-white px-3 py-2 rounded-xl font-semibold text-sm apple-button"
                                >
                                    Restore
                                </button>
                                <button
                                    onClick={() => permanentlyDeleteRestaurant(restaurant.id)}
                                    className="bg-red-500 text-white px-3 py-2 rounded-xl font-semibold text-sm apple-button"
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            <button
                onClick={() => setShowTrash(false)}
                className="w-full bg-gray-200 text-gray-700 px-4 py-3 rounded-xl font-semibold apple-button mt-4"
            >
                ← Back to Restaurants
            </button>
        </div>
    );
}
